<template lang="html">
  <div>
    <slot />
    <p class="registration-fence__title">
      {{ 'client.apply_modal.headline' | t }}
    </p>
    <p>{{ 'client.apply_modal.text' | t }}</p>
    <div class="flex-container align-center">
      <a
        class="button button--secondary"
        @click="$emit('close')"
      >{{ 'client.modal.close' | t }}</a>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style scoped>
.button {
  margin-top: 24px;
}
</style>
